module.exports = __webpack_public_path__ + "img/let-slip-cover.febc03f3.jpg";